export default {
  SET_QUANTUM_TOKEN(state, payload) {
    state.quantumToken = payload;
    // console.log(payload, "quantumToken");
    localStorage.setItem("quantumToken", payload);
  },
  SET_TOKEN(state, payload) {
    state.token = payload;
    // console.log(payload, "token");
    localStorage.setItem("token", payload);
  },
  SAVE_USER_DETAILS(state, user) {
    localStorage.setItem("loggedInUser", JSON.stringify(user));
    state.user = { ...user };
  },
  SAVE_USER_ID(state, userId) {
    state.userId = userId;
    localStorage.setItem("userId", userId);
  },
  SAVE_USER_TYPE(state, usertype){
    state.accountUserType = usertype
  },
  SAVE_QUANTUM_USER_ID(state, userId) {
    state.quantumUserId = userId;
    localStorage.setItem("quantumUserId", userId);
  },
  SAVE_ORGANIZATION_ID(state, organizationId) {
    localStorage.setItem("organizationId", organizationId);
    state.organizationId = organizationId;
  },
  SAVE_QUANTUM_ORGANIZATION_ID(state, organizationId) {
    localStorage.setItem("quantumOrganizationId", organizationId);
    state.quantumOrganizationId = organizationId;
  },
  SAVE_ORGANIZATION_DETAILS(state, organizationDetails) {
    localStorage.setItem(
      "organizationDetails",
      JSON.stringify(organizationDetails)
    );
    state.organizationDetails = organizationDetails;
  },
  SAVE_ACCOUNT_TYPE(state, payload){
    localStorage.setItem(
      "accountTypeObject",
      JSON.stringify(payload)
    );
    state.accountType = payload
  },
  SAVE_GOOGLE_KEY(state, payload){
    state.google_api_key = payload
  }
};
